import React, { Dispatch, useEffect, useState } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ReactComponent as RedirectIcon } from "../../../../assets/icons/external-link.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/Images/CalendarIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/Images/Delete.svg";
import { ReactComponent as PlayIcon } from "../../../../assets/Images/PlayIcon.svg";
import { ReactComponent as SuccessIcon } from "../../../../assets/Images/SuccessProjectIcon.svg";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import {
  getDecryptedItem,
  setEncryptedItem,
} from "../../../../utils/localStorageHelper";
import NoticeAlert from "../../Common/Alert/NoticeAlert";
import BaseButton from "../../Common/Buttons/BaseButton";
import {
  convertTimeDot,
  getCustomWriteAccess,
  hasCampaignsAccess,
  isEmpty,
  PAGE_SIZE_50,
  SlimAlert,
} from "../../CommonComponents/Common";
import { StarCheckBox } from "../../CommonComponents/CommonComponents";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import CommonPopup from "../../CommonComponents/PopUpCards/CommonPopup";
import DeletePopup from "../../CommonComponents/PopUpCards/DeletePopUp";
import DynamicTable from "../../CommonComponents/Table/DynamicTable";
import {
  checkForCampaignValidationAction,
  deleteCampaignAction,
  favouriteCampaignAction,
  getAllCampaignRunsAction,
  getCampaignAction,
  getCampaignCountAction,
  triggerCampaignAction,
} from "../../ProjectSection/CampaignSection/Store/Campaign.action";
import CreateInsightModal from "../CampaignDetails/CreateInsightModal";
import ConfirmationPopup from "../../CommonComponents/PopUpCards/ConfirmationPopup";
import { ReactComponent as ConfirmationIcon } from "../../../../assets/icons/Confirmation.svg";

const CampaignList = ({
  run,
  countSpin,
  pageIndex,
  star,
  handlePageNavigation,
  searchText,
}) => {
  const history = useHistory();
  const reducer: any = useSelector((state) => state);
  const dispatch: Dispatch<any> = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();

  const {
    CampaignReducer: { campaigns, campaignsCount },
    AccountReducer: { selectedAccount, accountRoles },
  } = reducer;

  const [state, setState] = useState<any>({
    campaignsList: [],
    selectedId: "",
    show: false,
    disabledCampaign: "",
    insightsPopup: false,
    selectedForInsights: {},
    rangePopup: false,
    start: "",
    end: "",
    campaignPopupData: {},
    selecetedIdx: "",
  });
  const {
    campaignsList,
    show,
    selectedId,
    disabledCampaign,
    insightsPopup,
    selectedForInsights,
    rangePopup,
    start,
    end,
    campaignPopupData,
    selecetedIdx,
  } = state;
  const [count, setCount] = useState(0);
  const [campaignRunList, setCampaignRunList] = useState<any>([]);
  const [rangeError, setRangeError] = useState(false);
  const [errorObj, setErrorObj] = useState({
    start: false,
    end: false,
  });
  const [allColumns, setAllColumns] = useState([]);
  const [rangeSpin, setRangeSpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successState, setSuccessState] = useState({
    successPopup: false,
    successPopupHeading: "",
    successPopupMessage: "",
  });
  const { successPopup, successPopupHeading, successPopupMessage } =
    successState;
  const [finalRunPopup, setFinalRunPopup] = useState({
    show: false,
    idx: null,
    campaign: null,
  });
  const [campaignPopUp, setCampaignPopup] = useState({
    show: false,
    text: "",
    heading: "",
    idx: null,
    campaign: null,
  });
  const [spin, setSpin] = useState(false);

  useEffect(() => {
    if (Array.isArray(campaigns)) {
      setState((prevState) => ({
        ...prevState,
        campaignsList: campaigns,
      }));
    }
  }, [campaigns]);

  useEffect(() => {
    const columns: any = [];

    if (getCustomWriteAccess(reducer) === "write") {
      columns.push({
        label: "",
        render: (campaign) => {
          return (
            <Box
              className="flex-xy-center"
              sx={{
                pl: 1.5,
              }}
            >
              {getCustomWriteAccess(reducer) === "write" && (
                <StarCheckBox
                  id={`ind1${campaign._id}`}
                  onChange={() => favouriteCampaign(campaign)}
                  checked={campaign.star}
                />
              )}
            </Box>
          );
        },
      });
    }

    columns.push(
      {
        label: "CAMPAIGN NAME",
        field: "campaignName",
        styles: { padding: 2 },
      },
      {
        label: "AUDIENCE LIST NAME",
        render: (campaign) => {
          const data = getName(campaign?.AudiencesName);
          return data?.name || "--";
        },
      },
      {
        label: "AUDIENCE COUNT",
        render: (campaign) => {
          const data = getName(campaign?.AudiencesName);
          return data?.count;
        },
      }
    );
    if (
      getCustomWriteAccess(reducer) === "write" ||
      getCustomWriteAccess(reducer, "camp")
    ) {
      columns.push({
        label: "RUN",
        render: (campaign, ind) => (
          <>
            {getCustomWriteAccess(reducer) === "write" &&
              getCustomWriteAccess(reducer) !== "read" && (
                <BaseButton
                  title="Run Campaign"
                  handleClick={() => rangeOpen(campaign, ind)}
                  disabled={
                    !!(
                      run ||
                      selectedAccount?.isPaused ||
                      ind?.toString() === disabledCampaign.toString()
                    )
                  }
                  startIcon={<PlayIcon />}
                />
              )}
            {getCustomWriteAccess(reducer) !== "write" &&
              getCustomWriteAccess(reducer, "camp") && (
                <BaseButton
                  title="Run Campaign"
                  handleClick={() => rangeOpen(campaign, ind)}
                  disabled={
                    !!(
                      run ||
                      selectedAccount?.isPaused ||
                      ind?.toString() === disabledCampaign.toString()
                    )
                  }
                  startIcon={<PlayIcon />}
                />
              )}
          </>
        ),
      });
    }

    columns.push({
      label: "ACTIONS",
      render: (campaign) => (
        <>
          {(hasCampaignsAccess(accountRoles) ||
            getCustomWriteAccess(reducer) === "write") && (
            <>
              <BaseButton
                variant="text"
                title="Create Insight"
                handleClick={() => goToSaveInsightsCampaignRunList(campaign)}
                styles={{ color: "#4280FF" }}
              />
              {!hasCampaignsAccess(accountRoles) && getCustomWriteAccess(reducer, "camp") && (
                <IconButton onClick={() => goToSchedule(campaign)}>
                  <CalendarIcon title="Schedule Campaign" />
                </IconButton>
              )}
              <IconButton onClick={() => handleDelete(campaign._id)}>
                <DeleteIcon title="Delete Campaign" />
              </IconButton>
            </>
          )}
          {(getCustomWriteAccess(reducer) === "write" ||
            getCustomWriteAccess(reducer) === "read" ||
            getCustomWriteAccess(reducer, "camp")) && (
            <IconButton onClick={() => goToCampaignRunList(campaign)}>
              <RedirectIcon title="Redirect" />
            </IconButton>
          )}
        </>
      ),
    });
    setAllColumns(columns);
  }, [searchText]);

  useEffect(() => {
    if (!isEmpty(campaignRunList)) {
      let matchStr = `${start} - ${end}`;
      const find = campaignRunList.find((cam) => cam.range === matchStr);
      find ? setRangeError(true) : setRangeError(false);
    }
    if (count > 0) {
      if (!start.trim() || !end.trim()) {
        setErrorObj(() => ({
          start: start ? false : true,
          end: end ? false : true,
        }));
        return;
      } else if (Number(start) === 0 || Number(end) === 0) {
        setErrorObj(() => ({
          start: start == 0 ? true : false,
          end: end == 0 ? true : false,
        }));
        return;
      } else if (
        Number(start) < 0 ||
        Number(end) < 0 ||
        Number(end) < Number(start)
      ) {
        setErrorObj(() => ({
          start: Number(start) < 0 ? true : false,
          end: Number(end) < 0 || Number(end) < Number(start) ? true : false,
        }));
        return;
      } else {
        setErrorObj(() => ({
          start: false,
          end: false,
        }));
      }
    }
  }, [start, end]);

  const handleDelete = (id) => {
    setState((prev) => ({
      ...prev,
      selectedId: id,
      show: true,
    }));
  };

  const confirmDelete = async () => {
    setLoading(true);
    let res: any = await dispatch(deleteCampaignAction(selectedId));
    setState((prev) => ({
      ...prev,
      selectedId: "",
      show: false,
    }));
    setLoading(false);
    if (res) {
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: "Campaign Deleted",
        successPopupMessage: "Campaign deleted successfully",
      }));
    }

    const obj = {
      pageIndex: getDecryptedItem("campaignpageIndex") || 1,
      pageSize: PAGE_SIZE_50,
      searchText: searchText,
    };

    if (star) {
      obj["star"] = "true";
      obj["pageIndex"] = 1;
    }
    await dispatch(getCampaignAction(projectId, obj));
    dispatch(getCampaignCountAction(projectId, obj));
  };

  const toggle = () => {
    setState((prev) => ({
      ...prev,
      show: !prev.show,
    }));
  };

  const getName = (audiences) => {
    let name: any = [];
    let count = 0;
    audiences?.forEach((aud) => {
      name.push(aud?.audienceName);
      count = count + aud?.audienceCount;
    });
    return { name: name.join(","), count };
  };

  const finalCampaignRun1 = async (campaign, idx) => {
    if (!campaign) return;

    setSpin(true);
    setRangeSpin(true);
    setState((prev) => ({
      ...prev,
      disabledCampaign: idx,
    }));
    let obj = {
      campaignId: campaign?._id,
      projectId,
    };
    let postObj = {
      start,
      end,
      consentForCalls: true,
    };
    let res: any = await dispatch(triggerCampaignAction(obj, postObj));
    if (res) {
      let obj = {
        type: "main",
        timeStamp: res?.timeStamp,
      };
      setEncryptedItem("campaign", campaign);
      setEncryptedItem("campaignRuns", obj);
      history.push(
        `/account/project/${projectId}/campaign-runs-details?campaignid=${campaign?._id}&campaignRuns=${res?.campaignRunId}&live=true`
      );
    } else {
      setState((prev) => ({
        ...prev,
        buttonDisable: false,
      }));
      setRangeSpin(false);
    }
    setState((prev) => ({
      ...prev,
      disabledCampaign: "",
    }));
    setSpin(spin);
    setRangeSpin(false);
  };

  const finalCampaignRun = async (campaign, idx) => {
    setCampaignPopup((prev) => ({
      ...prev,
      show: false,
      campaign: null,
      idx: null,
      text: "",
      heading: "",
    }));
    setFinalRunPopup({
      show: true,
      campaign: campaign,
      idx,
    });
  };

  const rangeOpen = async (campaign, idx) => {
    if (campaign?.range === true) {
      setState((prev) => ({
        ...prev,
        rangePopup: true,
        campaignPopupData: campaign,
        selecetedIdx: idx,
        disabledCampaign: idx,
      }));
      const obj = {
        pageIndex: 1,
        pageSize: 1000,
      };
      let res = await dispatch(
        getAllCampaignRunsAction(projectId, campaign?._id, obj)
      );
      setCampaignRunList(res);
    } else {
      runCampaign("", campaign, idx, false);
    }
  };

  const runCampaign = async (e, camp, id, fromRange) => {
    if (fromRange) {
      if (!start.trim() || !end.trim()) {
        setErrorObj(() => ({
          start: start ? false : true,
          end: end ? false : true,
        }));
        return;
      }
      if (Number(start) === 0 || Number(end) === 0) {
        setErrorObj(() => ({
          start: start == 0 ? true : false,
          end: end == 0 ? true : false,
        }));
        return;
      }
      if (Number(start) < 0 || Number(end) < 0 || Number(end) < Number(start)) {
        setErrorObj(() => ({
          start: Number(start) < 0 ? true : false,
          end: Number(end) < 0 || Number(end) < Number(start) ? true : false,
        }));
        return;
      }
    }
    setRangeSpin(true);
    let campaignFin = !isEmpty(camp) ? camp : campaignPopupData;
    let id1 = id ? id : selecetedIdx;

    if (fromRange) {
      await finalCampaignRun(campaignFin, id1);
    } else {
      let res: any = await dispatch(
        checkForCampaignValidationAction(campaignFin._id)
      );

      if (res) {
        let text = "";
        if (res.callerIdPresent && res?.campaignRan) {
          text =
            "List contains Caller Id number and Campaign is already run, Do you want to proceed?";
        } else if (res?.callerIdPresent) {
          text = "List contains Caller Id number, Do you want to proceed?";
        } else if (res?.campaignRan) {
          text = "This Campaign is already run, Do you want to proceed?";
        }

        if (text) {
          setCampaignPopup((prev) => ({
            ...prev,
            show: true,
            text: text,
            campaign: campaignFin,
            idx: id1,
          }));
        } else {
          await finalCampaignRun(campaignFin, id1);
        }
      }
    }
    setRangeSpin(false);
  };

  const goToCampaignRunList = async (campaign) => {
    let obj = {
      campaignName: campaign?.campaignName,
      _id: campaign?._id,
      range: campaign?.range,
    };
    setEncryptedItem("campaign", obj);
    history.push(
      `/account/project/${projectId}/campaign-runs?campaignid=${campaign?._id}`
    );
  };
  const goToSaveInsightsCampaignRunList = async (campaign) => {
    setState((prev) => ({
      ...prev,
      selectedForInsights: campaign,
      insightsPopup: true,
    }));
  };
  const goToSchedule = (data) => {
    let obj = {
      campaignName: data?.campaignName,
      _id: data?._id,
      range: data?.range,
    };
    setEncryptedItem("scheduleCampaignData", obj);
    history.push(
      `/account/project/${projectId}/schedule-campaign?campaignid=${data?._id}`
    );
  };

  const toggleRangeModal = () => {
    setState((prev) => ({
      ...prev,
      rangePopup: !prev.rangePopup,
      disabledCampaign: "",
      campaignPopupData: {},
      start: "",
      end: "",
    }));
    setCampaignRunList([]);
    setRangeError(false);
    setErrorObj({
      start: false,
      end: false,
    });
    setCount(0);
  };

  const onChange = (e) => {
    setCount(count + 1);
    e.persist();
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const favouriteCampaign = async (camp) => {
    const obj = {
      star: !camp?.star,
    };
    const res: any = await dispatch(favouriteCampaignAction(obj, camp._id));
    if (res)
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: "Favourites updated successfully",
        successPopupMessage: "",
      }));

    const obj1 = {
      pageIndex: getDecryptedItem("campaignpageIndex") || 1,
      pageSize: PAGE_SIZE_50,
      searchText: searchText,
    };
    const starred = Boolean(getDecryptedItem("starred"));

    if (starred) {
      obj1["star"] = "true";
      obj1["pageIndex"] = 1;
    }
    await dispatch(getCampaignAction(projectId, obj1));
    dispatch(getCampaignCountAction(projectId, obj1));
  };

  return (
    <Box>
      <DynamicTable
        columns={allColumns}
        data={campaignsList}
        showTotalRows={true}
        loading={countSpin}
        totalPages={Math.ceil(Number(campaignsCount) / PAGE_SIZE_50)}
        currentPage={pageIndex}
        handlePageChange={(event, newPage) => handlePageNavigation(newPage)}
        handlePrevious={() => handlePageNavigation(pageIndex - 1)}
        handleNext={() => handlePageNavigation(pageIndex + 1)}
        noDataAvailableMessage={"No Campaigns Available"}
        rowCount={campaignsList?.length}
        totalRowCount={campaignsCount}
      />
      {show && (
        <DeletePopup
          show={show}
          toggle={toggle}
          message={"Are you sure you want to delete the selected Campaign ?"}
          heading={"Delete Campaign"}
          handleDelete={confirmDelete}
          spin={loading}
        />
      )}
      {rangePopup && (
        <CommonModal
          show={rangePopup}
          toggle={toggleRangeModal}
          heading={`Range Data`}
          body={
            <>
              {campaignRunList?.length > 0 && (
                <Box
                  style={{
                    maxHeight: "200px",
                    overflow: "auto",
                    marginBottom: 1.5,
                  }}
                  sx={{
                    mb: 1,
                  }}
                >
                  <DynamicTable
                    columns={[
                      {
                        label: "Started At",
                        render: (campaign) =>
                          convertTimeDot(campaign?.createdAt),
                      },
                      {
                        label: "Range",
                        field: "range",
                      },
                    ]}
                    data={campaignRunList}
                    showTotalRows={true}
                    handlePageChange={() => {}}
                    rowCount={campaignRunList?.length}
                  />
                </Box>
              )}

              <NoticeAlert
                title="Tips"
                variant="warning"
                content="In the “Start” box, please mention from where the audience should begin. In the “End” box, put the final number for the audience range. Example: If you want run first 100 numbers write 1 in Start box and 100 in End box."
              />
              <Box
                className="flex-between"
                sx={{
                  gap: 2,
                  pb: 1,
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Typography className="font-14-grey mb-2">From</Typography>
                  <TextField
                    name="start"
                    value={start}
                    onChange={onChange}
                    error={!!errorObj.start}
                    helperText={
                      errorObj.start ? "Please enter a valid start value" : ""
                    }
                    variant="outlined"
                    fullWidth
                    placeholder="Start Range Number"
                    sx={commonStyles.inputField}
                    slotProps={{
                      htmlInput: {
                        type: "number",
                        min: 1,
                      },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Typography className="font-14-grey mb-2">To</Typography>
                  <TextField
                    name="end"
                    value={end}
                    onChange={onChange}
                    error={!!errorObj.end}
                    helperText={
                      errorObj.end ? "Please enter a valid end value" : ""
                    }
                    variant="outlined"
                    fullWidth
                    placeholder="End Range Number"
                    sx={commonStyles.inputField}
                    slotProps={{
                      htmlInput: {
                        type: "number",
                        min: 1 + Number(start),
                      },
                    }}
                  />
                </Box>
              </Box>

              {rangeError && (
                <SlimAlert
                  data="The mentioned range has already been processed; however, if you wish, you can run it again."
                  variant={"warning"}
                />
              )}
            </>
          }
          size={600}
          handleSave={() => runCampaign("", "", "", true)}
          spin={rangeSpin}
        />
      )}
      {insightsPopup && (
        <CreateInsightModal
          show={insightsPopup}
          toggle={() => setState((prev) => ({ ...prev, insightsPopup: false }))}
          campaignData={selectedForInsights}
          showPopUp={() =>
            setSuccessState((prev) => ({
              ...prev,
              successPopup: true,
              successPopupHeading: "Insights saved successfully",
              successPopupMessage: "",
            }))
          }
        />
      )}

      {successPopup && (
        <CommonPopup
          message={successPopupMessage}
          show={successPopup}
          toggle={() =>
            setSuccessState((prev) => ({
              ...prev,
              successPopup: false,
              successPopupHeading: "",
              successPopupMessage: "",
            }))
          }
          Icon={SuccessIcon}
          heading={successPopupHeading}
        />
      )}
      {finalRunPopup.show && (
        <ConfirmationPopup
          handleSave={() =>
            finalCampaignRun1(finalRunPopup?.campaign, finalRunPopup?.idx)
          }
          heading={"Run"}
          message={
            "Initiating this campaign implies you have the consent to call the provided numbers, and acceptance of our terms and conditions. Proceed only if you agree."
          }
          show={finalRunPopup.show}
          toggle={() =>
            setFinalRunPopup({
              show: false,
              campaign: null,
              idx: null,
            })
          }
          spin={spin}
          Icon={ConfirmationIcon}
          headerText="Run"
          confirmText="Run Campaign"
        />
      )}
      {campaignPopUp.show && (
        <ConfirmationPopup
          handleSave={() =>
            finalCampaignRun(campaignPopUp?.campaign, campaignPopUp?.idx)
          }
          heading={"Proceed Anyway"}
          message={campaignPopUp?.text}
          show={campaignPopUp.show}
          toggle={() => {
            setCampaignPopup((prev) => ({
              ...prev,
              show: false,
              campaign: null,
              idx: null,
            }));
            setState((prev) => ({
              ...prev,
              disabledCampaign: "",
            }));
            setRangeSpin(false);
          }}
          spin={false}
          Icon={ConfirmationIcon}
          headerText="Run"
        />
      )}
    </Box>
  );
};

export default CampaignList;
